export const DEFAULT_FIELDS_DESCRIPTION =
  "All of the fields below will be shown on expense forms as required.";
